<template>
  <div class="client application-notes">
    <!-- TODO: Emit the toggle and do it in TabbedFeedback -->
    <!-- <v-switch
      label="All"
      :value="allOpportunities ? 'true' : 'false'"
      :color="themes.client.light.input"
      @update="toggleAllOpportunities"
    /> -->
    <v-divider />

    <div
      class="py-1"
      style="height: 300px; overflow-y: scroll; overflow-x: hidden"
      ref="activities-container"
    >
      <div v-if="!orderedActivities[0] && !savingNote">No notes yet</div>

      <div
        v-for="(group, dayTimestamp) in dateGroupedActivities"
        :key="`activity-group-${dayTimestamp}`"
      >
        <div class="caption activity-date" :color="themes.client.light.muted">
          {{ new Date(Number(dayTimestamp)) | date("d MMM yyyy") }}
        </div>

        <div
          v-for="(activity, i) in group"
          :key="`activity-${i}`"
          class="container"
          :class="[
            { alt: isMe(activity.initiator) },
            isFromOtherOpportunity(activity) ? 'grey lighten-4' : '',
          ]"
        >
          <div class="activity-avatar hidden-xs-only">
            <v-tooltip bottom :color="themes.client.light.tooltip">
              <v-avatar
                slot="activator"
                :color="themes.client.light.primary"
                size="32"
              >
                <v-img
                  contain
                  :class="{
                    'v-avatar--grayscale': isFromOtherOpportunity(activity),
                  }"
                  :src="
                    activity.initiator.avatar ||
                    '/img/missing/avatars/original.png'
                  "
                  max-width="32"
                  @load="avatarLoaded = true"
                />
              </v-avatar>
              <span> {{ activity.initiator.fullName }} </span>
            </v-tooltip>
          </div>

          <div
            class="activity-content text-xs-left"
            :class="{ compact: isNote(activity) }"
          >
            <div
              v-if="isEvent(activity)"
              :class="
                isFromOtherOpportunity(activity)
                  ? 'grey lighten-5 grey--text'
                  : themes.client.light.secondary
              "
            >
              <div v-if="activity.content">
                Applied at {{ activity.content }}
              </div>
              <div v-else>
                Moved to {{ activity.status }}
                <span v-if="activity.reason">({{ activity.reason }})</span>
              </div>
            </div>

            <div v-if="isRating(activity)">
              <v-layout align-center class="pa-0">
                <v-flex xs12 class="rating-wrapper mt-1">
                  <ApplicationRating
                    :application="{
                      ...application,
                      applicationRating: activity.value,
                    }"
                    readonly
                  />
                </v-flex>
              </v-layout>
            </div>

            <div
              v-if="isFeedbackRequest(activity)"
              :class="themes.client.light.secondary"
            >
              <v-layout align-center class="pa-0">
                <v-icon
                  medium
                  v-if="activity.isPositive && activity.isPositive == true"
                  class="pa-2"
                  :color="
                    isFromOtherOpportunity(activity)
                      ? 'grey lighten-5 grey--text'
                      : themes.client.light.success
                  "
                >
                  mdi-thumb-up
                </v-icon>
                <v-icon
                  medium
                  v-else-if="
                    activity.hasOwnProperty('isPositive') &&
                    activity.isPositive == false
                  "
                  class="pa-2"
                  :color="
                    isFromOtherOpportunity(activity)
                      ? 'grey lighten-5 grey--text'
                      : themes.client.light.error
                  "
                >
                  mdi-thumb-down
                </v-icon>
                <v-icon medium class="pa-2" v-else
                  >mdi-share-variant-outline</v-icon
                >
                <div>
                  <span v-if="activity.response">
                    {{ activity.response }}
                  </span>
                  <v-tooltip
                    bottom
                    :color="themes.client.light.tooltip"
                    v-if="activity.responder"
                  >
                    <v-avatar slot="activator" size="32">
                      <v-img
                        contain
                        :src="
                          activity.responder.avatar ||
                          '/img/missing/avatars/original.png'
                        "
                        :class="{
                          'v-avatar--grayscale':
                            isFromOtherOpportunity(activity),
                        }"
                      />
                    </v-avatar>
                    <span> {{ activity.responder.fullName }} </span>
                  </v-tooltip>
                </div>
              </v-layout>
            </div>

            <div v-if="isFlag(activity)" :class="themes.client.light.secondary">
              <v-layout align-center class="pa-0">
                <div class="px-0">
                  <Flag v-if="activity.key" :value="activity" />
                </div>
              </v-layout>
            </div>

            <div
              v-if="isNote(activity)"
              class="client-note text-xs-left"
              :class="
                isFromOtherOpportunity(activity)
                  ? 'grey lighten-5 grey--text'
                  : themes.client.light.primaryActionButton
              "
            >
              <span>
                <v-icon
                  :color="
                    isFromOtherOpportunity(activity)
                      ? 'grey lighten-5'
                      : themes.client.light.primaryActionButton
                  "
                >
                  mdi-triangle
                </v-icon>
              </span>
              <div>
                <markdown
                  :html="false"
                  :source="activity.content"
                  class="markdown"
                />
              </div>
            </div>

            <div
              class="text-xs-right time-stamp"
              :class="{
                'white--text':
                  isNote(activity) && !isFromOtherOpportunity(activity),
              }"
              style="font-size: 9px"
            >
              <span
                v-if="
                  isFromOtherOpportunity(activity) &&
                  activity.opportunity &&
                  activity.opportunity.name
                "
              >
                {{ activity.opportunity.name }}
              </span>
              <span> {{ new Date(activity.createdAt) | date("HH:mm") }} </span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="savingNote && savingNote.length">
        <div class="caption" :color="themes.client.light.muted">
          {{ new Date() | date("d MMM YYY") }}
        </div>

        <div class="container alt">
          <div class="activity-avatar hidden-xs-only">
            <v-progress-circular
              size="32"
              indeterminate
              :color="themes.client.light.success"
            >
              <v-avatar size="30">
                <img
                  :src="user.avatar || 'img/missing/avatars/original.png'"
                  v-img-orientation-changer
                />
              </v-avatar>
            </v-progress-circular>
          </div>

          <div
            class="activity-content text-xs-left compact"
            style="max-width: 100%"
          >
            <div
              class="client-note text-xs-left"
              :class="themes.client.light.primaryActionButton"
            >
              <span>
                <v-icon :color="themes.client.light.primary"
                  >mdi-triangle</v-icon
                >
              </span>
              <markdown :html="false" :source="savingNote" class="markdown" />
            </div>

            <div
              class="text-xs-right time-stamp white--text"
              style="font-size: 9px"
            >
              <span>Saving...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-divider />
    <v-card-actions class="px-0 py-0" v-if="!readonly && isManager">
      <v-text-field
        box
        placeholder="Add a note here"
        v-model="newNote"
        :append-icon="sending ? 'mdi-loading' : 'mdi-note-plus'"
        @click:append="saveNote"
        @keyup.enter.exact="saveNote"
        :color="themes.client.light.input"
      />
    </v-card-actions>
  </div>
</template>

<script>
// Components
import ApplicationRating from "@/components/client/applications/ApplicationRating";
import Flag from "@/components/client/flags/Flag";
import Markdown from "vue-markdown";

// Helpers
import colors from "@/data/colors";
import _ from "lodash";

export default {
  props: {
    application: Object,
    readonly: { type: Boolean, default: false },
    allOpportunities: { type: Boolean, default: true },
  },

  mounted() {
    this.scrollDown();
  },

  components: { ApplicationRating, Flag, Markdown },

  data() {
    return {
      newNote: "",
      savingNote: "",
      sending: false,
      colors,
    };
  },

  computed: {
    user() {
      return this.$store.getters["auth/user"];
    },

    isManager() {
      return this.$store.getters["client/opportunities/currentIsManager"]();
    },

    orderedActivities() {
      if (
        !this.application ||
        !this.application.activities ||
        !this.application.activities[0]
      )
        return [];

      const activities = JSON.parse(
        JSON.stringify(this.application.activities)
      );

      return activities
        .filter((a) =>
          this.allOpportunities ? true : !this.isFromOtherOpportunity(a)
        )
        .sort(({ createdAt: a }, { createdAt: b }) => {
          if (new Date(a) > new Date(b)) return 1;
          if (new Date(a) < new Date(b)) return -1;
          return 0;
        });
    },

    dateGroupedActivities() {
      if (!this.orderedActivities[0]) return [];
      return _.groupBy(this.orderedActivities, (a) => {
        const createdAt = new Date(a.createdAt);
        return new Date(
          createdAt.getFullYear(),
          createdAt.getMonth(),
          createdAt.getDate()
        ).getTime();
      });
    },
  },

  watch: {
    application: {
      deep: true,
      handler: function (value) {
        this.scrollDown();
      },
    },
  },

  methods: {
    isLast: (index, array) => array.length === index + 1,

    isEvent: (activity) => activity.type === "Application event",

    isRating: (activity) => activity.type === "Application rating",

    isFeedbackRequest: (activity) => activity.type === "Feedback request",

    isFlag: (activity) => activity.type === "Flag",

    isNote: (activity) => activity.type === "Application note",

    isMe(user) {
      if (_.get(this, "user.id") && _.get(user, "id"))
        return this.user.id === user.id;
    },

    isFromOtherOpportunity(activity) {
      if (
        _.get(this.application, "opportunity.id") &&
        _.get(activity, "opportunity.id")
      ) {
        return this.application.opportunity.id !== activity.opportunity.id;
      }

      return false;
    },

    scrollDown() {
      this.$nextTick(() => {
        const container = this.$refs["activities-container"];
        if (container) container.scrollTop = container.scrollHeight;
      });
    },

    toggleAllOpportunities(value) {
      this.$emit("toggleAll", value);
    },

    saveNote() {
      this.savingNote =
        this.newNote.length > 0 ? this.newNote.trim() : this.newNote;
      this.newNote = "";
      if (this.savingNote.length > 0) {
        this.sending = true;
        this.$nextTick(() => {
          this.scrollDown();
        });
        this.$http
          .post("client/application_notes", {
            application: this.application.id,
            note: this.savingNote,
          })
          .then(
            (response) => {
              this.$store.dispatch("snackbarSuccess", "Note Saved");
              return this.$store
                .dispatch("client/applications/fetch", {
                  id: this.application.id,
                })
                .then((response) => {
                  this.savingNote = "";
                  this.scrollDown();
                });
            },
            (errors) => {
              this.$store.dispatch("snackbarError", "Note Failed");
              this.savingNote = "";
              this.scrollDown();
            }
          )
          .finally(() => (this.sending = false));
      }
    },
  },
};
</script>

<style lang="scss">
.client.application-notes {
  .muted {
    opacity: 0.7;
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0.1rem 0.7rem;
    margin: 0 auto;
    max-width: 100%;

    .activity-avatar {
      padding-right: 0.8rem;
      padding-left: 0;
    }

    .v-avatar--grayscale {
      opacity: 0.6;
    }

    & .activity-content {
      box-sizing: border-box;
      position: relative;
      padding: 0.3rem 10% 0.3rem 0;
      min-width: 50%;

      > div,
      > div:first-child {
        line-height: 1rem;
        border-radius: 5px;
        padding: 0.5rem 1rem 0.8rem 0.8rem;
      }

      &.compact {
        flex-grow: unset;
      }

      & .time-stamp {
        opacity: 0.7;
        padding: 0.7rem 0.2rem 0.2rem 0.4rem;
        margin-top: -1.5rem;
      }

      .rating-wrapper {
        min-width: 130px;
        padding-right: 10px;
      }

      & div.client-note {
        border-radius: 5px;
        padding: 0.6rem 1rem 0.3rem 0rem;
        opacity: 1;

        > div {
          padding: 0 1.8rem 0.5rem 0.8rem;
        }

        & div.markdown > p {
          margin-bottom: 0px;
        }

        & .v-icon {
          position: absolute;
          transform: translateY(-70%) rotate(30deg);
          top: 50%;
          left: -0.5rem;
        }
      }
    }
  }

  & .container.alt {
    flex-direction: row-reverse;

    & .activity-avatar {
      padding-left: 0.8rem;
      padding-right: 0;
    }

    & .activity-content {
      padding-left: 10%;
      padding-right: 0%;
    }

    & div.client-note {
      & .v-icon {
        position: absolute;
        transform: translateY(-70%) rotate(-30deg);
        top: 50%;
        right: -0.5rem;
        left: auto;
      }
    }
  }

  .v-input {
    font-size: 14px;
  }
  .v-text-field .v-input__slot {
    margin-bottom: 0;
    border-radius: 0;
    min-height: 40px;
  }
  .v-text-field .v-input__append-inner {
    margin-top: 8px;
  }
  .v-text-field__details {
    display: none;
  }
  input[type="text"] {
    margin-top: 4px;
  }

  i.mdi-loading {
    animation: rotation 2s infinite linear;
  }
}
</style>
